<template>
  <teleport to="body">
    <div class="modal">
      <slot></slot>
    </div>
  </teleport>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class Modal extends Vue {}
</script>

<style lang="scss">
.modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
}
</style>
